import auth from '~/middleware/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const currentRoute = to.fullPath;

  if (currentRoute.includes('/admin') || currentRoute.includes('/dashboard')) {
    return auth(to, from);
  }
});